export const validate = {
  lotteryLength: new RegExp(/^[\d ]{0,6}$/),
  zipcode: new RegExp(/^[\d ]{0,5}$/),
  digitOnly: new RegExp(/^\d+$|^$/),
  phoneNumber: new RegExp(/^$|^[0]{0}[\d ]{1,10}$/),
};

export const tsToStr = () =>
  parseInt(
    new Date()
      .toISOString()
      .slice(-22)
      .replace(/(\.|-|:|T|Z)/g, ""),
  ).toString(36);
export const sumPxQ = (arr, basePrice) => {
  const result = arr.reduce(
    (r, x) => (r += x.quantity * (x.price + basePrice)),
    0,
  );
  if (parseInt(result)) {
    return result;
  } else {
    return "xxx";
  }
};
export const sum = (arr) => arr.reduce((r, x) => (r += x), 0);
export const addressToHtmlString = ({
  address,
  subDistrict,
  district,
  province,
  zipcode,
}) => {
  return `${address}<br>
  ${subDistrict}${district}<br/>
  ${province}${zipcode}`;
};

export const thaiDate = (date) => {
  return (
    (date || new Date()).toLocaleString("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }) + " น."
  );
};
// export const thaiRoundDate = (roundDate) => {
//   if (!roundDate) return ""
//   let [year, month, date] = roundDate?.split("-")
//   month = ["มกราคม",
//     "กุมภาพันธ์",
//     "มีนาคม",
//     "เมษายน",
//     "พฤษภาคม",
//     "มิถุนายน",
//     "กรกฎาคม",
//     "สิงหาคม",
//     "กันยายน",
//     "ตุลาคม",
//     "พฤศจิกายน",
//     "ธันวาคม",][parseInt(month) - 1]
//   return `${date} ${month} ${year}`
// }
export const roundDateToDate = (roundDate) => {
  if (!roundDate) return "";
  return new Date(roundDate).toLocaleDateString("th-TH", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
export const boolean2YN = (value) =>
  value === true
    ? "Yes"
    : value === false
      ? "No"
      : value === undefined
        ? "No"
        : value;
export const yN2Boolean = (value) =>
  value === "Yes" ? true : value === "No" ? false : value;

export const bankTranslater = (value) => {
  const bankForAccountant = {
    ธนาคารกรุงเทพฯ: "002 กรุงเทพ",
    ธนาคารไทยพาณิชย์: "014 ไทยพาณิชย์",
    ธนาคารกสิกรไทย: "004 กสิกรไทย",
    ธนาคารกรุงศรีอยุธยา: "025 กรุงศรีอยุธยา",
    ธนาคารกรุงไทย: "006 กรุงไทย",
    ธนาคารทิสโก้: "067 ทิสโก้",
    ธนาคารออมสิน: "030 ออมสิน",
    ธนาคารอาคารสงเคราะห์: "033 อาคารสงเคราะห์",
    ธนาคารอิสลามแห่งประเทศไทย: "066 อิสลามแห่งประเทศไทย",
    ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร: "034 เพื่อการเกษตรและสหกรณ์",
    ธนาคารทหารไทยธนชาต: "011 ทหารไทยธนชาต จำกัด (มหาชน)",
    ธนาคารซีไอเอ็มบีไทย: "022 ซีไอเอ็มบี",
    ธนาคารยูโอบี: "024 ยูโอบี",
    "ธนาคารแลนด์ แอนด์ เฮ้าส์": "073 แลนด์แอนด์เฮ้าส์",
    ธนาคารเกียรตินาคินภัทร: "069 เกียรตินาคิน",
  };
  return bankForAccountant[value];
};

export const unixToDate = (unix) => {
  if (!unix) return "";
  try {
    let date;
    if (typeof unix === "object") {
      if (typeof unix.toDate === "function") {
        date = unix.toDate();
      } else if (typeof unix._seconds === "number") {
        date = new Date(unix._seconds * 1000);
      } else if (typeof unix.seconds === "number") {
        date = new Date(unix.seconds * 1000);
      } else {
        date = new Date(unix);
      }
    } else if (typeof unix === "number") {
      date = new Date(unix < 1e11 ? unix * 1000 : unix);
    } else {
      const num = Number(unix);
      if (!isNaN(num) && num > 0) {
        date = new Date(num < 1e11 ? num * 1000 : num);
      } else {
        date = new Date(unix);
      }
    }
    if (!date || isNaN(date.getTime())) return "";
    const json = date.toJSON();
    return json ? json.slice(0, 10) : "";
  } catch {
    return "";
  }
};

export const unixToDateAndTime = (unix) => {
  if (!unix) return "";
  try {
    let date;
    if (typeof unix === "object") {
      if (typeof unix.toDate === "function") {
        date = unix.toDate();
      } else if (typeof unix._seconds === "number") {
        date = new Date(unix._seconds * 1000);
      } else if (typeof unix.seconds === "number") {
        date = new Date(unix.seconds * 1000);
      } else {
        date = new Date(unix);
      }
    } else if (typeof unix === "number") {
      date = new Date(unix < 1e11 ? unix * 1000 : unix);
    } else {
      const num = Number(unix);
      if (!isNaN(num) && num > 0) {
        date = new Date(num < 1e11 ? num * 1000 : num);
      } else {
        date = new Date(unix);
      }
    }
    if (!date || isNaN(date.getTime())) return "";
    const json = date.toJSON();
    return json ? json.slice(0, 16) : "";
  } catch {
    return "";
  }
};

export const dateToUnix = (date) => {
  return new Date(date).valueOf();
};

export const getThaiDateFormat = (date) => {
  const shortMonth = {
    มกราคม: "ม.ค.",
    กุมภาพันธ์: "ก.พ.",
    มีนาคม: "มี.ค.",
    เมษายน: "เม.ย.",
    พฤษภาคม: "พ.ค.",
    มิถุนายน: "มิ.ย.",
    กรกฎาคม: "ก.ค.",
    สิงหาคม: "ส.ค.",
    กันยายน: "ก.ย.",
    ตุลาคม: "ต.ค.",
    พฤศจิกายน: "พ.ย.",
    ธันวาคม: "ธ.ค.",
  };
  const fullDate = date
    .toLocaleDateString("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    .split(" ");

  return fullDate[0] + " " + shortMonth[fullDate[1]] + " " + fullDate[2];
};

export const getThaiDateAndTimeFormat = (date) => {
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
};

export const role = {
  admin: "Admin",
  superAdmin: "Team Lead Admin",
  dev: "Developer",
  scanner: "Scanner",
  superScanner: "Team Lead Scanner",
  inventory: "Inventory",
  superAccount: "Team Lead Accountant",
  account: "Accountant",
  marketing: "Marketing",
};

export const resizeImage = (file, maxW = 600, maxH = 1200) =>
  new Promise((resolve, reject) => {
    if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type))
      reject(false);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const img = document.createElement("img");
    img.onload = function () {
      const iw = img.width;
      const ih = img.height;
      let scale = 1;
      if (iw > maxW || ih > maxH) {
        scale = Math.min(maxW / iw, maxH / ih);
      }
      const iwScaled = iw * scale;
      const ihScaled = ih * scale;
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      context.drawImage(img, 0, 0, iwScaled, ihScaled);
      const format = file.type === "image/png" ? "image/png" : "image/jpeg";
      resolve(canvas.toDataURL(format, 0.95)); // ใช้คุณภาพ 0.95 เพื่อความละเอียดสูงแต่บีบอัดไฟล์ดีกว่า
    };
    img.src = URL.createObjectURL(file);
  });
